/* eslint-disable react/prop-types */
import { useState, useCallback } from "react";
import { Modal, Button, Text, LoadingOverlay } from "@mantine/core";
import OTPInput, { ResendOTP } from "otp-input-react";
import { showNotification } from "@mantine/notifications";
import { ConfirmModal } from "./ConfirmModal";
import { lcaSendOtp, lcaVerifyOtp} from "../../api/lcaAuth";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const renderButton = (buttonProps) => {
  let {remainingTime} = buttonProps 
  
  return (
    <Button
      {...buttonProps}
      style={{
        marginTop: "1em",
        backgroundColor: "#fff",
        color: "#1C3351",
        border: "1px solid #1C3351",
        opacity: remainingTime === 0 ?  1: 0.5,
      }}
    >
      Resend
    </Button>
  );
};

const renderTime = (remainingTime) => {
  return (
    <Text style={{ marginTop: "1em" }}>
      {" "}
      <span style={{ color: "#1C3351" }}>{remainingTime}</span> seconds
      remaining
    </Text>
  );
};

// When we get the success message for getting the OTP we will open the modal
export function OTPModal({ rollNo, openOTP, setOpenOTP, timer }) {
  // const [opened, setOpened] = useState(true);

  const [OTP, setOTP] = useState("");   
  const [openReg, setOpenReg] = useState(false);
  const [regToken, setRegToken] = useState("");
  const [userLoad, setUserLoad] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [responseData, setResponseData] = useState(null);
  
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      // console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha("yourAction");
    //console.log(token);
    // Do whatever you want with the token
    // console.log(rollRef.current);
    //  Route to send otp
    const data = {
      roll: localStorage.getItem("roll"),
      recaptcha: token,
    };
    try {
      setUserLoad(true);
      const res = await lcaSendOtp(data);
      setUserLoad(false);
      console.log(res);
      if (res.status == 200) {
        setOTP("");
        showNotification({
          title: "OTP Verification",
          message: "OTP has been sent successfully to your Lynx",
          styles: (theme) => ({
            root: {
              backgroundColor: theme.colors.blue[6],
              borderColor: theme.colors.blue[6],

              "&::before": { backgroundColor: theme.white },
            },

            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
              "&:hover": { backgroundColor: theme.colors.blue[7] },
            },
          }),
        });
      }
    } catch (err) {
      setUserLoad(false);
      //console.log(err.response.data.message);
      showNotification({
        title: "OTP Verification",
        message: `${err.response.data.message}`,
        styles: (theme) => ({
          root: {
            backgroundColor: theme.colors.red[6],
            borderColor: theme.colors.red[6],

            "&::before": { backgroundColor: theme.white },
          },

          title: { color: theme.white },
          description: { color: theme.white },
          closeButton: {
            color: theme.white,
            "&:hover": { backgroundColor: theme.colors.blue[7] },
          },
        }),
      });
    }
  }, [executeRecaptcha]);

  const handleSubmit = async () => {
    const data = {
      roll: rollNo,
      otp: OTP,
    };
  
    try {
      setUserLoad(true);
      const res = await lcaVerifyOtp(data);
      setUserLoad(false);
      if (res.status == 200) {
        setOpenOTP(false);
        setRegToken(res.data.token);
        setOTP("");
        localStorage.setItem("regToken", res.data.token);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("id", res.data.id)
        localStorage.setItem("type", res.data.type)
        // setOpenReg(true);
        showNotification({
          title: "OTP Verification",
          message: "OTP has been verified successfully",
          styles: (theme) => ({
            root: {
              backgroundColor: theme.colors.blue[6],
              borderColor: theme.colors.blue[6],

              "&::before": { backgroundColor: theme.white },
            },

            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
              "&:hover": { backgroundColor: theme.colors.blue[7] },
            },
          }),
        });

        if (res.data.isProfileConfirmed) {
          // need to navigate home page
          
          showNotification({
            title: "Login Successfully",
            message: `Welcome Back! ${res.data.name}`,
            styles: (theme) => ({
              root: {
                backgroundColor: theme.colors.blue[6],
                borderColor: theme.colors.blue[6],
  
                "&::before": { backgroundColor: theme.white },
              },
  
              title: { color: theme.white },
              description: { color: theme.white },
              closeButton: {
                color: theme.white,
                "&:hover": { backgroundColor: theme.colors.blue[7] },
              },
            }),
          });

          setTimeout(() => {
            window.open("/dashboard/announcements", "_self");
          }, 1200);

        } else {
          setResponseData(res.data); // Store the response data in the state
          setOpenReg(true);
        }
      }
      
    } catch (err) {
      setUserLoad(false);
      showNotification({
        title: "OTP Verification",
        message: `${err.response.data.message}`,
        styles: (theme) => ({
          root: {
            backgroundColor: theme.colors.red[6],
            borderColor: theme.colors.red[6],

            "&::before": { backgroundColor: theme.white },
          },

          title: { color: theme.white },
          description: { color: theme.white },
          closeButton: {
            color: theme.white,
            "&:hover": { backgroundColor: theme.colors.red[7] },
          },
        }),
      });
    }
  };
  return (
    <>
      {/* It should be replaced with Confirmation component */}
      {
        <ConfirmModal
          openReg={openReg}
          setOpenReg={setOpenReg}
          regToken={regToken}
          resData={responseData} // Pass the data as a prop to ConfirmModal
        />
      }

      <Modal
        opened={openOTP}
        onClose={() => setOpenOTP(false)}
        title={
          <Text weight={"bold"} size={"xl"} color="#1C3351">
            OTP Verification
          </Text>
        }
        closeOnEscape={false}
        closeOnClickOutside={false}
        withCloseButton={false}
        styles={{
          modal: { backgroundColor: "#fff" },
        }}
      >
        <LoadingOverlay visible={userLoad} />
        {/* Modal content */}
        <Text style={{ marginBottom: "1em", color: "#1C3351" }}>
          Enter the OTP received in the Lynx
        </Text>
        <OTPInput
          value={OTP}
          onChange={setOTP}
          autoFocus
          OTPLength={6}
          otpType="number"
          disabled={false}
          secure
          inputStyles={{
            border: "1px solid #0063F8",
            borderRadius: "5px",
            color: "#0063F8",
          }}
        />

        <ResendOTP
          renderButton={renderButton}
          renderTime={renderTime}
          maxTime={Math.floor(timer * 60)}
          onResendClick={handleReCaptchaVerify}
          style={{
            color: "#0063F8",
          }}
        />

        <Button
          mt="xl"
          size="sm"
          onClick={handleSubmit}
          styles={{
            root: {
              backgroundColor: "#0063F8",
              borderRadius: "20px",
              display: "flex",
              margin: "0 auto",
              padding: "10 20",
            },
          }}
        >
          Submit
        </Button>
      </Modal>

      {/* <Group position="center">
        <Button radius="xl" sx={{ height: 30 }} onClick={() => setOpened(true)}>
          OTP
        </Button>
        </Group> */}
    </>
  );
}
